const MOBILE_OR_TABLET_QUERY = "(max-width: 1024px), (pointer: coarse)";

export const shouldRequirePlacementFullscreen = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }

  const isMobileOrTablet = window.matchMedia?.(MOBILE_OR_TABLET_QUERY)?.matches;
  const supportsFullscreen =
    Boolean(document.fullscreenEnabled) &&
    typeof document.documentElement?.requestFullscreen === "function";

  return supportsFullscreen && !isMobileOrTablet;
};
